module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/bnr_chapel_photo-e8705bc81cd7d9c19a3472f8b30e74b7.jpg";